import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getMyProfile, upsertMyProfile, patchMyProfile } from "../api/profile";

export function useProfile() {
    return useQuery({
        queryKey: ["profile"],
        queryFn: getMyProfile,
    });
}

export function useUpsertProfile() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: upsertMyProfile,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["profile"] }),
    });
}

export function usePatchProfile() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: patchMyProfile,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["profile"] }),
    });
}
